
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93VlzOss_45830r_457Y_nsKBBB1ApRiUw14MyWb6zZBcsr4oMeta } from "/codebuild/output/src2080415864/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasL0EgyYaciJnaUKByQQ3lcWXlOdRweXmDYVDbsiGW0ekMeta } from "/codebuild/output/src2080415864/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexBmamR9AoIbxbRBN6MeAqrE0DWQIzfrruCpKubuNZfj0Meta } from "/codebuild/output/src2080415864/src/ark/pages/blog/index.vue?macro=true";
import { default as temas7EPXy5Ft2msIj_kQ7LlTA_4k9_453KtBgdHADnmyUFSWEMeta } from "/codebuild/output/src2080415864/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisa7kfmJcA9vzmFV2nbzN3_qTUvupKu8M3CBdofkuXvhDMMeta } from "/codebuild/output/src2080415864/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaGIbTMRO_bRFohca_5BBfb6bqdSPoIaFLf3Hq1dteJrMMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesaCKOjvWfS4z2Y8oVVC3nJ_456p4OKNwNwlEJNx9mxDMRAMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasJabyv2fxaOj_HSiXQaMk0KJ1LTtdFEQL3oFZVapheWIMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casaGSnWqpJ1Gp4OcBMpjFd3X92VXAFpHfMC_7KQOAI7JcEMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoZPGEed91IYhg_Vt0v9VYoQbe02j3fizTn3DC4iyrNokMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadorajqU_45YzwSVsPm9WCwPVASBQvkt55HC8Lx0rkjlZBL2uUMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoQDw5mJqrnIJBlagtvAdMgijo2EkXySJFxOmQVgRNG5AMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaPZRIlGuVuR1ge04TosZ2IGdMIjZUNmHkSTxw9pWBkScMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simular57COeAEVEnO9nuA4Ug_OCas6R3CF04Nrqt_aNJonDYAMeta } from "/codebuild/output/src2080415864/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetGdt71xGN0RXa3Kiv_45P2IHm_S3_4GM9TFnS3jye7tpsAMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovel8lG01bs5_45qOUI_RxK07R_nuyNEL5KGOc5S_wTieQb2gMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaos6cpMz0Bq7XldI9X1J7LZtpcuwIcsqJ8dt9znOtduUsMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualL2NitJ6upTodnuvjpMNWTgU6K_45s2j5xR_var3R9GIdYMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contacto3461rg6JujdHBFNrCvofWvBilGYxYB8oFBFWSELNFBUMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simulartmBLZsYmz_45CMf40Y0eSr_453vFo4MuZ5Aqel5nFdYNBycMeta } from "/codebuild/output/src2080415864/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_934RTdA_y8NLnIWM7JAVs2dDojNrh3ZFrNvBq8muJLcJIMeta } from "/codebuild/output/src2080415864/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93LIMwFB04BD58qY4eDc3_yJhEVAYF8O0VrfgyFZ_45WljAMeta } from "/codebuild/output/src2080415864/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumo1d8upsU399jyG3EprlbEF9qh1bhNLvI7yLVh0ZgMa2kMeta } from "/codebuild/output/src2080415864/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeslnez2k_kIYHpGr29_UQWUIsmMmW_45XIzzdFum5hvsm4Meta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxanrcdQZj1ekd40C0KCqdpoMSRPvLUwtdGQLvjT5Kufl0Meta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactodr1hC8EXB3NybPbLW99O9wk8dpghGp7MkfPiMudoXrEMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoVygVA1FxUqxF_WvY7f7IHIh5Z5g2cbJnFNEQPLc4USUMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiracKgYPHjbH74BGIQRuAAc3dkqoHfwZlheFBoBu7mbQNUMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo9QuRlkZRtkMLNPxL1OJ8_lRgA0SyoFDcIoh8yt45xTcMeta } from "/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularFRmImtBaFxgMssmVCeQJD4L4LBMs7ALe2w3JAQu_45MlQMeta } from "/codebuild/output/src2080415864/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93uDagUpBYWGndIPZQirVCMLRPEHcn970QKKLqPmq2aGgMeta } from "/codebuild/output/src2080415864/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosbxd32SMOBmw_45nAP1QJYAjx1BcRd4HNxys1YGNOvhjBAMeta } from "/codebuild/output/src2080415864/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexerA_459NNZcN3InDFA6bzk5wEJuz6N22Mvn_owDhNbRx0Meta } from "/codebuild/output/src2080415864/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93rYeJfNm9JnEmKcjBdZoHWS_wuVaHrEKP9i_oy9hKEMkMeta } from "/codebuild/output/src2080415864/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93tNyhcK1_nx8pR19IzpVsyGxFFKMLZ8BN_45j8mQza_45yO8Meta } from "/codebuild/output/src2080415864/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simular57COeAEVEnO9nuA4Ug_OCas6R3CF04Nrqt_aNJonDYAMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simulartmBLZsYmz_45CMf40Y0eSr_453vFo4MuZ5Aqel5nFdYNBycMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularFRmImtBaFxgMssmVCeQJD4L4LBMs7ALe2w3JAQu_45MlQMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src2080415864/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93uDagUpBYWGndIPZQirVCMLRPEHcn970QKKLqPmq2aGgMeta || {},
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosbxd32SMOBmw_45nAP1QJYAjx1BcRd4HNxys1YGNOvhjBAMeta || {},
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93rYeJfNm9JnEmKcjBdZoHWS_wuVaHrEKP9i_oy9hKEMkMeta || {},
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93tNyhcK1_nx8pR19IzpVsyGxFFKMLZ8BN_45j8mQza_45yO8Meta || {},
    component: () => import("/codebuild/output/src2080415864/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]